import { MapMarkerCheckIcon } from './MapMarkerCheckIcon';

/**
 * author: Google
 * id FA10B579-AC1E-48F7-BF8C-AB7F1380F3F9
 * name map-marker-check
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-check.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const WhereToVoteIcon = MapMarkerCheckIcon;
export default WhereToVoteIcon